import { render } from "./FilterMulti.vue?vue&type=template&id=2c446534&bindings={\"disabled\":\"props\",\"selected\":\"props\",\"numeric\":\"props\",\"selectedArray\":\"options\",\"display\":\"options\"}"
import script from "./FilterMulti.vue?vue&type=script&lang=js"
export * from "./FilterMulti.vue?vue&type=script&lang=js"
script.render = render

export default script